/** @typedef {{ pageKey: string; title: string; titleEn?: string; pageNumber?: string | null }} PageFeedbackContext */

/** Email stored for anonymous page feedback rows in Supabase. */
export const ANONYMOUS_FEEDBACK_EMAIL = 'anonymous';

/** @param {string} pageId */
export function appPageKey(pageId) {
  return `page:${pageId}`;
}

/** @param {string} topicId */
export function jyotishaTopicPageKey(topicId) {
  return `jyotisha:${topicId}`;
}

/** @param {string} topicId */
export function numerologyTopicPageKey(topicId) {
  return `numerology:${topicId}`;
}

/** @param {string} pageKey @returns {boolean} */
export function isJyotishaTopicPageKey(pageKey) {
  return pageKey.startsWith('jyotisha:');
}

/** @param {string} pageKey @returns {boolean} */
export function isNumerologyTopicPageKey(pageKey) {
  return pageKey.startsWith('numerology:');
}

/** @param {string} pageKey @returns {string | null} */
export function topicIdFromPageKey(pageKey) {
  if (!isJyotishaTopicPageKey(pageKey)) return null;
  return pageKey.slice('jyotisha:'.length);
}

/** @param {string} pageKey @returns {string | null} */
export function numerologyTopicIdFromPageKey(pageKey) {
  if (!isNumerologyTopicPageKey(pageKey)) return null;
  return pageKey.slice('numerology:'.length);
}

const PAGE_LABELS = {
  home: { hi: 'प्रगति', en: 'Progress' },
  jyotisha: { hi: 'ज्योतिष', en: 'Jyotisha' },
  'jyotish-marga': { hi: 'मार्ग', en: 'Path' },
  phaladeepika: { hi: 'फलदीपिका', en: 'Phaladeepika' },
  sadhana: { hi: 'साधना', en: 'Sadhana' },
  profile: { hi: 'प्रगति', en: 'Progress' },
  help: { hi: 'सहायता', en: 'Help' },
  'ask-guru': { hi: 'AskGuru', en: 'AskGuru' },
  bhagyank: { hi: 'अंक ज्योतिष', en: 'Ankotish' },
  'birth-chart': { hi: 'जन्म कुंडली', en: 'Birth chart' },
  'lo-shu': { hi: 'Lo Shu', en: 'Lo Shu grid' },
  'time-cycles': { hi: 'समय चक्र', en: 'Time cycles' },
  pinnacles: { hi: 'Pinnacles', en: 'Pinnacles' },
  'personal-year': { hi: 'व्यक्तिगत वर्ष', en: 'Personal year' },
  'name-analysis': { hi: 'नाम विश्लेषण', en: 'Name analysis' },
  mahadasha: { hi: 'महादशा', en: 'Mahadasha' },
  kua: { hi: 'Kua', en: 'Kua number' },
  'lucky-colours': { hi: 'शुभ रंग', en: 'Lucky colours' },
  'ist-devta': { hi: 'इष्ट देवता', en: 'Ishta Devta' },
  mobile: { hi: 'मोबाइल', en: 'Mobile number' },
  'friendly-numbers': { hi: 'मित्र अंक', en: 'Friendly numbers' },
  'unfriendly-numbers': { hi: 'शत्रु अंक', en: 'Unfriendly numbers' },
  'address-vibration': { hi: 'पता कंपन', en: 'Address vibration' },
  'number-vibration': { hi: 'अंक कंपन', en: 'Number vibration' },
};

/**
 * @param {string} pageId
 * @returns {PageFeedbackContext}
 */
export function buildAppPageContext(pageId) {
  const labels = PAGE_LABELS[pageId] ?? { hi: pageId, en: pageId };
  return {
    pageKey: appPageKey(pageId),
    title: labels.hi,
    titleEn: labels.en,
    pageNumber: null,
  };
}
